import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { sendVisitorPing } from "./lib/visitorPing";

const Portfolio = () => {
  useEffect(() => {
    // Fire-and-forget visitor ping (throttled to 1/day per browser via localStorage)
    sendVisitorPing({
      pageUrl: window.location.href,
      referrer: document.referrer,
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-[#f4f1ea]">
      <Header />
      <main>
        <Hero />
        <About />
        <Skills />
        <Experience />
        <Education />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#0f0f0f",
            color: "#f4f1ea",
            border: "1px solid rgba(244, 241, 234, 0.12)",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
